import * as styles from "./ErrorMessage.styles";

interface Props {
  error?: string;
  errorMessages?: Record<string, string>;
  prefix?: string;
}

const ErrorMessage = ({ error = "", errorMessages = {}, prefix = "" }: Props) => {
  if (!errorMessages[error]) return null;
  return (
    <span
      css={styles.errorMessage}
      data-testid="error-message"
    >{`${prefix}${errorMessages[error]}`}</span>
  );
};

export { ErrorMessage };
